import { StateNode } from '@ansys-internal/awf-angular/store';
import { ConceptSections, ConceptSubSection } from '../../shared/enums';

export type PageStateModel = {
  section: ConceptSections;
  subsection: ConceptSubSection;
  comparisonToolJobIds: string[] | null;
  resultId: string | null;
};

export type PageStateInput =
  | {
      type: PageStateExecuteEnum.SET_SECTION;
      property: 'section';
      section: ConceptSections | null;
    }
  | {
      type: PageStateExecuteEnum.SET_SUBSECTION;
      property: 'subsection';
      subsection: ConceptSubSection | null;
    }
  | {
      type: PageStateExecuteEnum.SET_RESULT_ID;
      property: 'resultId';
      resultId: string | null;
    }
  | {
      type: PageStateExecuteEnum.SET_COMPARISON_TOOL_JOB_IDS;
      property: 'comparisonToolJobIds';
      comparisonToolJobIds: string[] | null;
    };

export type PageStateValueMap = {
  [PageStateExecuteEnum.SET_SECTION]: ConceptSections | null;
  [PageStateExecuteEnum.SET_SUBSECTION]: ConceptSubSection | null;
  [PageStateExecuteEnum.SET_RESULT_ID]: string | null;
  [PageStateExecuteEnum.SET_COMPARISON_TOOL_JOB_IDS]: string[] | null;
};

export enum PageStateExecuteEnum {
  SET_SECTION = 'SET_SECTION',
  SET_SUBSECTION = 'SET_SUBSECTION',
  SET_RESULT_ID = 'SET_RESULT_ID',
  SET_COMPARISON_TOOL_JOB_IDS = 'SET_COMPARISON_TOOL_JOB_IDS',
}

export class PageState implements StateNode<PageStateModel> {
  key: string = 'page-state';
  defaultValue: () => PageStateModel = () => ({
    section: ConceptSections.COMPONENT,
    subsection: ConceptSubSection.MAIN,
    comparisonToolJobIds: null,
    resultId: null,
  });
}
